<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :inline="true">
      <el-row class="margb10">
        <el-col :span="5"
                class="padt5">
          <!-- 邮件主题 -->
          <el-form-item label="邮件主题">
            <el-input :placeholder="$t('user.input')"
                      v-model="dataForm.mailTheme"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 创建人 -->
          <el-form-item label="创建人">
            <el-input :placeholder="$t('user.input')"
                      v-model="dataForm.createUserName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 发送状态 -->
          <el-form-item label="发送状态">
            <el-select v-model="dataForm.sendState"
                       clearable
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in mailStauts"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 创建时间 -->
          <el-form-item label="创建时间">
            <el-date-picker type="date"
                            v-model="dataForm.createTime"
                            :placeholder="$t('user.select')"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 查询 -->
          <el-col :span="24">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       @click="getDataList()">{{$t('user.query')}}</el-button>
          </el-col>
          <!-- 重置 -->
          <el-col :span="24">
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="again">{{$t('reset')}}</el-button>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="top"
             :inline="true"
             v-show="isShow">
      <el-row class="margb10">
        <el-col :span="5"
                class="padt5">
          <!-- 发送时间 -->
          <el-form-item label="发送时间">
            <el-date-picker type="date"
                            v-model="dataForm.sendTime"
                            :placeholder="$t('user.select')"
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 显示展开更多 -->
    <ToggleDiv @toggle="toggle"></ToggleDiv>
    <div class="search"
         style="margin-top:7px">
      <!-- 新建 -->
      <el-button class="el-button-columnBtn"
                 @click="changeRevise()"
                 v-if="$hasPermission('AUTH000028')">{{ $t('user.newlyBuild') }}</el-button>
    </div>
    <div class="table-user table"
         style="margin-top:8px;">
      <el-table :data="dataList"
                v-loading="dataListLoading"
                border
                style="width: 100%">
        <!-- 序号 -->
        <el-table-column prop="mailId"
                         label="No."
                         width="100"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 序号 -->
        <el-table-column prop="userId"
                         label="用户Id"
                         width="120"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 邮件主题 -->
        <el-table-column prop="mailTheme"
                         label="邮件主题"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="createTime"
                         label="创建时间"
                         width="200"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 发送时间 -->
        <el-table-column prop="sendTime"
                         label="发送时间"
                         width="200"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 发送状态 -->
        <el-table-column prop="sendState"
                         label="发送状态"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sendState == '10'">未发送</span>
            <!-- 不活动 -->
            <span v-if="scope.row.sendState == '20'">已发送</span>
            <!-- 不活动 -->
            <span v-if="scope.row.sendState == '30'">发送失败</span>
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column prop="createUserName"
                         label="创建人"
                         show-overflow-tooltip
                         align="left"
                         fixed
                         header-align="center">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         width="100"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="$hasPermission('AUTH000026')"
                                  @click.native="mailview(scope.row.mailId)">{{ $t('view') }}</el-dropdown-item>
                <el-dropdown-item v-if="$hasPermission('AUTH000025')"
                                  @click.native="changeCheck(scope.row.mailId)">{{ $t('update') }}</el-dropdown-item>
                <el-dropdown-item v-if="$hasPermission('AUTH000027')"
                                  @click.native="deleteMail(scope.row.mailId)">{{ $t('delete') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="block"
           style="float: right;margin-top: 20px;margin-right: 30px; margin-bottom: 20px">
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </el-card>
</template>

<script>
import ToggleDiv from '@/components/toggle-div'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commmail/list',
        getDataListIsPage: true
      },
      dataForm: {},
      isShow: false,
      mailStauts: _this.enums['mailStauts'],
      dataListLoading: false,
      dataList: [],
      mailId: ''
    }
  },
  methods: {
    toggle(val) {
      this.isShow = val
    },
    // 新建
    changeRevise() {
      this.$request.post(`/sys/commmail/save`, {}).then((res, total, code, data) => {
        this.$router.push({
          name: 'sys-sendmail',
          query: {
            mailId: res,
            newbuild: '1'
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 修改
    changeCheck(id) {
      this.$router.push({
        name: 'sys-sendmail',
        query: {
          mailId: id
        }
      })
    },
    // 查看
    mailview(id) {
      this.$router.push({
        name: 'sys-mail-view',
        query: {
          mailId: id
        }
      })
    },
    // 删除
    deleteMail(id) {
      this.$confirm(this.$t('user.delet'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$request.post(`/sys/commmail/delete`,
          {
            deleteId: id
          }
        ).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 重置
    again() {
      this.dataForm = {}
      this.getDataList()
    }
  },
  components: {
    ToggleDiv
  }
}
</script>
